import React from "react";

import Styles from "./StatusLabel.styles";
import { StatusLabelProps as Props } from "./StatusLabel.types";

const StatusLabel: React.FC<Props> = props => {
  const { text, icon, backgroundColor } = props;

  return (
    <Styles className="StatusLabel" backgroundColor={backgroundColor}>
      {icon ? icon : <div className="StatusLabel__circle" />}
      <p className="StatusLabel__text">{text}</p>
    </Styles>
  );
};

export default StatusLabel;
